import moment from "moment";

const locale = require("moment/locale/en-gb");
moment.updateLocale("en-gb", locale);

export default moment;
